<main [ngClass]="{ 'd-none': hasErrors && !isLoading }">
  <ngx-landing-side-nav [event]="event" [persona]="persona" [isLoading]="isLoading"></ngx-landing-side-nav>
  <ngx-landing-previewer [event]="event" [persona]="persona" (descriptionChange)="onDescriptionChange($event)"></ngx-landing-previewer>
</main>
<!-- Not Found -->
<main *ngIf="hasErrors && !isLoading" class="not-found-section h-100 d-flex align-items-center justify-content-center">
  <img src="https://library.micetribe.com/images/CLP-not-found.svg" alt="not-found" />
</main>
